import { z } from "zod";

/**
 * SC-3392 — the live Inbox badge event. Dependency-free (D04a): the publisher (server), the SSE
 * endpoint and the client hook all parse the same wire shape through this schema, so a malformed
 * payload on any leg fails the same way (log, no invalidation, no sound) instead of three different
 * hand-rolled guesses.
 *
 * `orgId` / `userId` ride along for defense in depth only — the channel itself
 * (`inbox:events:<orgId>:<userId>`) already scopes delivery to one recipient.
 */
export const inboxEventSchema = z.object({
  type: z.literal("INBOX_NOTIFICATION"),
  orgId: z.string().uuid(),
  userId: z.string().uuid(),
  timestamp: z.string(),
  playSound: z.boolean().default(true),
});

export type InboxEvent = z.infer<typeof inboxEventSchema>;
